import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import Sms from './components/Confirmations/Sms';
import Google2FA from './components/Confirmations/Google2FA';
import SwitchConfirmationMethodScreen from './components/SwitchConfirmationMethodScreen';
import PushNotification2FA from './components/Confirmations/PushNotification2FA';
import { PASSWORD_RECOVERY_STATUSES, TWO_FACTOR_AUTH_TYPES } from 'components/common/constants';
import { getAvailableConfirmationTypes } from 'services/authUtils';

const ActionConfirmation = ({ authStore, userStore, passwordRecoveryStore, isPasswordRecovery = false }) => {
  // Anonymous flow is for login/registration, when user is not yet authenticated
  const isAnonymousFlow = !userStore.isInitialized;

  if (isAnonymousFlow) {
    const store = isPasswordRecovery ? passwordRecoveryStore : authStore;
    const handleCode = (code, disableSend) => {
      store.setCode(code);
      if (!disableSend && !store.isLoading) {
        if (isPasswordRecovery) {
          if (store.recoveryStatus === PASSWORD_RECOVERY_STATUSES.PHONE_CONFIRM) {
            store.sendPhoneCode();
          }
        } else {
          store.sendCode();
        }
      }
    };
    const resendSecurityCode = () => {
      if (isPasswordRecovery) {
        if (store.recoveryStatus === PASSWORD_RECOVERY_STATUSES.PHONE_CONFIRM) {
          store.resendPhoneCode();
        }
      } else {
        store.resendSecurityCode();
      }
    };

    if (store.isShowSwitchConfirmationMethodScreen) {
      return (
        <SwitchConfirmationMethodScreen
          onSwitchMethod={store.forceSwitchToAnotherConfirmationType}
          onBack={() => store.setIsShowSwitchConfirmationMethodScreen(false)}
          currentConfirmationType={store.confirmationActionType}
          availableConfirmationTypes={getAvailableConfirmationTypes()}
        />
      );
    } else if (store.confirmationActionType === TWO_FACTOR_AUTH_TYPES.GOOGLE_AUTH) {
      return (
        <Google2FA sms={store.values.code} error={store.error} handleSms={handleCode} resendCode={resendSecurityCode} />
      );
    } else if (store.confirmationActionType === TWO_FACTOR_AUTH_TYPES.PUSH_NOTIFICATION) {
      return <PushNotification2FA />;
    } else {
      const phone = isPasswordRecovery ? store.generalFields.phoneNumber : store.phone;

      return (
        <Sms
          phone={phone}
          sms={store.values.code}
          error={store.error}
          handleSms={handleCode}
          resendCode={resendSecurityCode}
          isForgotPassword={isPasswordRecovery}
        />
      );
    }
  }

  return null;
};

ActionConfirmation.propTypes = {
  authStore: MobXPropTypes.observableObject,
  userStore: MobXPropTypes.observableObject,
  passwordRecoveryStore: MobXPropTypes.observableObject,
  isPasswordRecovery: PropTypes.bool
};

export default inject('authStore', 'userStore', 'passwordRecoveryStore')(observer(ActionConfirmation));
